import realNameAuthService from '../utils/realNameAuthService';

export default {
  install(Vue) {
    // 注册全局指令
    Vue.directive('real-name-auth', {
      bind(el, binding, vnode) {
        const featureName = binding.value || '此功能';
        console.log("bindingfeatureName",featureName)
        // 添加点击事件监听
        el.addEventListener('click', function(event) {
          // 阻止默认行为
          // event.preventDefault();
          // event.stopPropagation();
          
          // 获取用户信息
          const userStore =  vnode.context.userStore;
          const userInfo = userStore?.userInfo;
          
          if (!userInfo) {
            // 用户未登录，显示登录提示
            if (window.$showLogin) {
              window.$showLogin({
                success: () => {
                  // 登录成功后重新检查实名认证
                  checkRealNameAuth();
                },
                cancel: () => {
                  console.log('用户取消登录');
                }
              });
            }
            return;
          }
          
          // 检查实名认证
          checkRealNameAuth();
          
          function checkRealNameAuth() {
            if (realNameAuthService.needRealNameAuth(userInfo)) {
              // 需要实名认证
              realNameAuthService.checkBeforeFeature(
                userInfo,
                featureName,
                () => {
                  // 用户选择立即认证
                  if (vnode.context.$refs.realNameAuth) {
                    vnode.context.$refs.realNameAuth.show(true);
                  } else {
                    // 如果没有实名认证组件，显示全局认证
                    if (window.$showRealNameAuth) {
                      window.$showRealNameAuth(true);
                    }
                  }
                },
                () => {
                  // 用户取消认证
                  console.log('用户取消实名认证');
                  checkRealNameAuth();
                }
              );
            } else {
              // 已实名认证，执行原始功能
              if (binding.arg === 'click') {
                // 触发原始点击事件
                const originalClick = el._originalClick;
                if (originalClick) {
                  originalClick.call(el, event);
                }
              }
            }
          }
        });
        
        // 保存原始的点击事件
        el._originalClick = el.onclick;
      },
      
      unbind(el) {
        // 清理事件监听
        console.log("unbindfeatureName",el)
        el.removeEventListener('click', el._clickHandler);
        delete el._originalClick;
      }
    });
    
    // 注册全局方法
    Vue.prototype.$checkRealNameAuth = function(featureName, onAuth, onSkip) {
      const userInfo = this.userStore?.userInfo;
      return realNameAuthService.checkBeforeFeature(userInfo, featureName, onAuth, onSkip);
    };
    
    // 注册全局属性
    Vue.prototype.$realNameAuthService = realNameAuthService;
  }
}; 